'use client'

import { MessageSquare } from 'lucide-react'
import { trackEvent, trackLovedPetsConversion } from '@/lib/analytics'
import { SMS_HREF } from './LovedPetsCTAs'

/**
 * Persistent bottom contact bar, phones only (≤767px). Keeps the text-first
 * lifeline one tap away no matter how far the family scrolls.
 */
export default function StickyContactBar() {
  return (
    <div className="hidden sm:flex fixed bottom-0 inset-x-0 z-50 items-stretch px-3 py-3 bg-white/95 backdrop-blur border-t border-black/10 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]">
      <a
        href={SMS_HREF}
        onClick={() => {
          trackEvent('lovedpets_cta_clicked', { channel: 'sms', variant: 'sticky' })
          trackLovedPetsConversion({ channel: 'sms', variant: 'sticky' })
        }}
        className="flex-1 inline-flex items-center justify-center gap-2 bg-[#004da9] hover:bg-[#003d8a] text-white text-[16px] font-semibold px-5 py-3.5 rounded-full transition-colors"
      >
        <MessageSquare className="w-5 h-5" />
        Text Janine
      </a>
    </div>
  )
}
